import { DemographicGroup, Metric } from "@models/ConsumerData";

export const TREND_CHART_QUARTERS = [
    { id: "q1", title: "Q1" },
    { id: "q2", title: "Q2" },
    { id: "q3", title: "Q3" },
    { id: "q4", title: "Q4" },
];

export const CONSUMER_SERIES_COLORS = [
    "#66DEB2",
    "#7B16F5",
    "#F19B38",
    "#50B1F9",
    "#D82E85",
];

export const CONSUMER_METRIC_LABELS: Record<Metric, string> = {
    [Metric.LoveIt]: "Love It",
    [Metric.LikeIt]: "Like It",
    [Metric.Neutral]: "Neutral",
    [Metric.Dislike]: "Dislike",
    [Metric.HateIt]: "Hate It",
    [Metric.KnowIt]: "Know It",
    [Metric.HaveTriedIt]: "Have Tried It",
    [Metric.HadManyTimes]: "Had Many Times",
    [Metric.LoveLikeIt]: "Love It/Like It",
};

export const DEMOGRAPHIC_LABELS: Record<DemographicGroup, string> = {
    [DemographicGroup.Gender]: "Gender",
    [DemographicGroup.Generation]: "Generation",
    [DemographicGroup.Ethnicity]: "Ethnicity",
    [DemographicGroup.Region]: "Region",
};

export const DEFAULT_CONSUMER_METRIC: Metric = Metric.KnowIt;
export const DEFAULT_DEMOGRAPHIC: DemographicGroup = DemographicGroup.Generation;

export interface DemographicOption {
    id: DemographicGroup;
    title: string;
}

export const DEMOGRAPHIC_OPTIONS: DemographicOption[] = [
    { id: DemographicGroup.Gender, title: DEMOGRAPHIC_LABELS[DemographicGroup.Gender] },
    { id: DemographicGroup.Generation, title: DEMOGRAPHIC_LABELS[DemographicGroup.Generation] },
    { id: DemographicGroup.Ethnicity, title: DEMOGRAPHIC_LABELS[DemographicGroup.Ethnicity] },
    { id: DemographicGroup.Region, title: DEMOGRAPHIC_LABELS[DemographicGroup.Region] },
];

export const buildMetricStorageKey = (categoryId: string) =>
    `category-profile-consumer-metric-${categoryId}`;

export const buildDemographicStorageKey = (categoryId: string) =>
    `category-profile-consumer-demographic-${categoryId}`;

export const buildAffinityTooltip = (metricLabel: string) =>
    `INDEX: % of consumers who ${metricLabel} each item listed vs. % of gen pop consumers who ${metricLabel} (100=average)`;
